import React, { useEffect, useState } from 'react';
import {
    Container,
    Card,
    CardBody,
    GoBack,
    Col,
    Row,
    Alert,
    Spinner,
    Icon, Button // Aggiunto Icon dal kit
} from 'design-react-kit';
import SpinnerCustom from "../../layout/Spinner";

import { useNavigate, useLocation } from 'react-router-dom';
import { properties } from '../../../config/properties';

// Definiamo gli stili ispirati al componente Dashboard
const styles = {
    customCard : {
        height: '100%',
        boxShadow: '0 4px 12px rgba(0, 48, 102, 0.08)', // Ombra leggera e professionale
        border: 'none',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
    },
    cardBody: {
        padding: '2rem', // Spaziatura interna generosa
    },
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    fieldLabel: {
        color: '#333', // Grigio scuro per leggibilità
        fontSize: '0.875rem',
        marginBottom: '0.25rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
        wordBreak: 'break-word',
    },
    delegaItem: {
        padding: '1.5rem 0',
        borderBottom: '1px solid #e6e9f2', // Separatore più tenue
    },
    lastDelegaItem: {
        padding: '1.5rem 0',
        borderBottom: 'none',
    },
    firmaContainer: {
        textAlign: 'center',
        padding: '1rem',
    },
    firmaImage: {
        maxWidth: '100%',
        width: 'auto',
        height: '150px',
        minHeight: '150px',
        maxHeight: '150px',
        objectFit: 'contain',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#f8f9fa',
        padding: '0.5rem',
        display: 'block',

    },
    firmaPlaceholder: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '120px',
        backgroundColor: '#f8f9fa',
        border: '1px dashed #ced4da',
        borderRadius: '6px',
        color: '#6c757d',
        fontStyle: 'italic',
        fontSize: '0.9rem',
    },
    sidebar: {
        backgroundColor: "#0b5ed7", // blu
        padding: "1rem",
        borderRadius: "8px",
        minWidth: "180px",
        color: "white",
        fontWeight: "600",
    },
    sidebarButton: {
        margin: "0.5rem 0",
        width: "100%",
    },
};


// Componente per visualizzare la firma (leggermente aggiornato)
function FirmaComponent({ base64String, label }) {
    if (!base64String) {
        return (
            <div style={styles.firmaPlaceholder}>
                <span>Nessuna {label}</span>
            </div>
        );
    }
    const imgSrc = base64String.startsWith('data:image') ? base64String : `data:image/png;base64,${base64String}`;

    return (
        <img
            src={imgSrc}
            alt={label}
            style={styles.firmaImage}
        />
    );
}


const ProfiloSpecimen = ({user}) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { ricerca } = location.state || {};
    const [profilo, setProfilo] = useState(null);
    const [loading, setLoading] = useState(true);

    const [alert, setAlert] = useState({visible: false, type: '', message: ''});

    const [isDownloading, setIsDownloading] = useState(false);

    useEffect(() => {
        setAlert({visible: false, type: '', message: ''});
        const idProfilo = ricerca?.dati?.id;
        if (idProfilo) {
            getDettagliProfilo({ id: idProfilo, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente });
        } else {

            setAlert({visible: true, type: 'danger', message: 'ID del profilo non trovato. Impossibile caricare i dati.'});
            setLoading(false);
        }
    }, [ricerca]);

    const getDettagliProfilo = async (params) => {
        setLoading(true);

        setAlert({visible: false, type: '', message: ''});

        try {
            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/dettagliProfilo",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(params),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setProfilo(null);

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!res.ok) throw new Error(`Errore HTTP: ${res.status}`);
            const data = await res.json();
            if (data && Object.keys(data).length > 0) {
                setProfilo(data);
            } else {
                throw new Error("Il profilo restituito è vuoto o non valido.");
            }
        } catch (e) {

            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            setProfilo(null);
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async () => {

        try {

            setAlert({visible: false, type: '', message: ''});
            setIsDownloading(true);

            const param = {

                "id" : ricerca?.dati?.id,
                "nome" : profilo.nome,
                "cognome" : profilo.cognome,
                "userID": user.userID,
                "cciaa": user.cciaa,
                "gruppoUtente":user.gruppoUtente
            }

            const response = await fetch(properties.fullBaseUrl + properties.baseAppUrl + "/std/service/getPdfDettaglioPersona", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(param),
            });

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                setIsDownloading(false);

                return;

            }

            if (!response.ok) {
                throw new Error("Errore nel download del PDF");
            }

            const blob = await response.blob();
            const fileName = "Specimen_" + profilo.nome + "_" + profilo.cognome + ".pdf";

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName; // qui imposti il nome
            document.body.appendChild(link);
            link.click();
            link.remove();



        } catch (error) {
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
        }finally {
            setIsDownloading(false);
        }
    };

    // Funzione per renderizzare il contenuto principale
    const renderContent = () => {
        if (loading) {
            return (
                <div className="text-center p-5">
                    <SpinnerCustom active double />
                    <p className="mt-3">Caricamento del profilo...</p>
                </div>
            );
        }


        if (profilo) {
            const { deleghe = [] } = profilo;
            return (

                <Container>

                    {/* Card: Dati Anagrafici e Posizione */}
                    <Card style={styles.card} className="mb-4 shadow-bg border-0 p-3 card-hover">
                        <CardBody className="d-flex flex-column" style={styles.cardBody}>

                            <Row>
                                <Col md={6}>

                                    <h2 style={styles.sectionTitle}>
                                        <Icon icon="it-user" size="sm" style={styles.titleIcon}/>
                                        Dati Anagrafici
                                    </h2>
                                    <div>
                                        <p style={styles.fieldLabel}>Nome</p>
                                        <p style={styles.fieldValue}>{profilo.nome || '-'}</p>
                                        <p style={styles.fieldLabel}>Cognome</p>
                                        <p style={styles.fieldValue}>{profilo.cognome || '-'}</p>
                                        <p style={styles.fieldLabel}>Codice Fiscale</p>
                                        <p style={styles.fieldValue}>{profilo.codFiscale || '-'}</p>
                                    </div>

                                </Col>
                                <Col md={6}>

                                    <h2 style={{...styles.sectionTitle}}>
                                        <Icon icon="it-card" size="sm" style={styles.titleIcon}/>
                                        Posizione
                                    </h2>
                                    <div>
                                        <p style={styles.fieldLabel}>Camera</p>
                                        <p style={styles.fieldValue}> {profilo?.cciaa === "ST" ? "InfoCamere" : (profilo?.cciaa || "-")}</p>
                                        <p style={styles.fieldLabel}>Ruolo</p>
                                        <p style={styles.fieldValue}>{profilo.ruoloTitolo || '-'}</p>
                                        <p style={styles.fieldLabel}>Area competenza</p>
                                        <p style={styles.fieldValue}>{profilo.areaDescrizione || '-'}</p>
                                    </div>

                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {/* Card: Firma e Deleghe */}
                    <Card style={styles.card} className="mb-4 shadow-bg border-0 p-3 card-hover">
                        <CardBody style={styles.cardBody} className="d-flex flex-column">
                            <h2 style={styles.sectionTitle}>
                                <Icon icon="it-pencil" size="sm" style={styles.titleIcon}/>
                                Firma
                            </h2>
                            <Row>
                                <Col md={7} style={styles.firmaContainer}>
                                    <p style={{...styles.fieldValue, fontSize: "large"}}>
                                        Firma per esteso
                                    </p>
                                    <FirmaComponent base64String={profilo.firma?.firma} label="firma"/>
                                </Col>
                                <Col md={5} style={styles.firmaContainer}>
                                    <p style={{...styles.fieldValue, fontSize: "large"}}>
                                        Firma abbreviata
                                    </p>
                                    <div style={{display: "flex", justifyContent: "center"}}>
                                        <FirmaComponent
                                            base64String={profilo.firma?.siglaFirma}
                                            label="sigla"
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-between align-items-start">
                            <div>
                                    <p style={{...styles.fieldValue, fontSize: "large"}}>
                                        Firma depositata il: {profilo.firma.dataFirma || "-"}
                                    </p>
                                </div>
                                <span style={{color: profilo.firma.stato === 'PUBBLICATA' ? 'green' : 'red'}}
                                      className="text-uppercase">
                                                    {profilo.firma.stato}
                                </span>
                            </div>


                            <h2 style={{...styles.sectionTitle, marginTop: '2.5rem'}}>
                                <Icon icon="it-key" size="sm" style={styles.titleIcon}/>
                                Deleghe
                            </h2>
                            <div>
                                {deleghe.length > 0 ? (
                                    deleghe.map((delega, index) => (
                                        <div key={index}
                                             style={index === deleghe.length - 1 ? styles.lastDelegaItem : styles.delegaItem}>
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <p style={styles.fieldLabel}>Descrizione</p>
                                                    <p style={{...styles.fieldValue, fontSize: "x-large"}}>
                                                        {delega.descrizione || "-"}
                                                    </p>
                                                </div>
                                                <span
                                                    style={{color: delega.stato === 'SCADUTA' || delega.stato === 'NON PUBBLICATA' ? 'red' :  'green'}}
                                                      className="text-uppercase">
                                                    {delega.stato}
                                                </span>
                                            </div>
                                            <p style={styles.fieldValue}>
                                                Valida dal: {delega.dataInizio || '-'}
                                                {delega.dataFine && ` fino al: ${delega.dataFine}`}
                                            </p>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-muted">Nessuna delega disponibile.</p>
                                )}
                            </div>
                        </CardBody>
                    </Card>

                    <SpinnerCustom active={!setProfilo}/>
                </Container>

            );
        }
        return null;
    };


    return (
        <div className="bg-white py-5 py-lg-6">

            <Container>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1>Dettagli Profilo</h1>
                    <Button className={"btn btn-outline-primary"} type="click" onClick={handleDownload} disabled={isDownloading}>
                        {isDownloading ? <Spinner active small /> : "Download Pdf"}
                    </Button>
                </div>
                <div>
                    {alert.visible && (
                        <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({...alert, visible: false})}>
                            {alert.message}
                        </Alert>
                    )}
                </div>
                {renderContent()}
            </Container>
        </div>
    );


};

export default ProfiloSpecimen;